import React from 'react';

const Services = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div class="content-wrapper">
            <div className="span-two">
            I offer the following services  
            </div>  
            <div>
            <b>Session work</b> 
             </div>
             <div>
             <b>Life Path Numerology</b>
            </div>
            
           </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div class="content-wrapper">  
            <div className="span-two">
            Я предлагаю следующие услуги  
            </div>  
            <div>
            <b>Сессионная работа</b> 
            </div>
            <div>
            <b>Жизненный путь по числу</b>
            </div>
           </div>
        );
    }
}
export default Services;
